export default __webpack_public_path__ + "static/media/m-signup-14-tour-pg-1.86541e05.jpg";